import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text, Card } from '../../Components'
import { useState, useEffect } from 'react'
import { savePrepayment, usePrepayment } from './Functions'
import { invalidateQuery, useCQuery } from '../../Services/QueryCache'
import { useAuth } from '../../Provider/AuthProvider'
import { FC } from '../../Services/FeathersClient'
import { FloatInput } from '../Gigi/GigiForm/TransferField/InputForm'
import { InputTimeDate } from '../Attendances'

export function Prepayment ({ codClienteNerone }) {
  const { prepaymentId } = useParams()
  const navigate = useNavigate()
  const [prepayment, setPrepayment, isSuccess] = usePrepayment(prepaymentId, codClienteNerone)
  const { id = '' } = prepayment || {}
  const [checkError, setCheckError] = useState(false)
  const { data: agencies = [], isSuccess: isSuccessAgencies } = useCQuery(['environments'])
  const [now] = useState(new Date())

  const save = async () => {
    setCheckError(true)
    if (!prepayment.startDate || !prepayment.environmentId || !prepayment.type || !prepayment.bookingType) {
      // message e return per uscire dalla funzione
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi mancanti' })
      return
    }
    setCheckError(false)
    const elaboratedPrepayment = { ...prepayment }
    elaboratedPrepayment.startDate = new Date(prepayment.startDate)
    const res = await savePrepayment(elaboratedPrepayment)
    if (!res) return
    invalidateQuery(['prepayment', 'prepaymentList'])
    if (res?.id && prepaymentId === 'new') {
      await FC.service('timePrepayment').create({ userId: res.userId, prepaymentId: res.id, createdAt: now, endAt: new Date(), time: new Date() - now })
    }
    res?.id && navigate('/prepayment/list')
    return res
  }

  const isNew = id === 'new'
  if (!isSuccess || !prepayment || !isSuccessAgencies) return <Spinner />
  return (
    <Flex fw>
      <Text value={`${isNew ? 'Inserisci' : 'Modifica'} Attività`} title bold size={30} />
      <Flex js fw row wrap style={{ marginTop: 20 }}>
        <Flex style={{ width: '49.5%', marginRight: '0.5%' }}>
          <InputTimeDate
            value={[new Date(prepayment.startDate), (date) => setPrepayment('startDate', date)]}
            error={checkError && !prepayment.startDate}
            label='Data Inizio' labelTime='Ora Inizio'
          />
        </Flex>
        <Flex style={{ width: '49.5%', marginLeft: '0.5%' }}>
          <FloatInput
            type='dropdown' error={checkError && !prepayment?.environmentId} filter
            value={[prepayment.environmentId, (value) => setPrepayment('environmentId', value)]}
            options={agencies?.map(({ id, agencyName, codClienteNerone }) => ({ label: agencyName + ' - ' + codClienteNerone, value: id }))}
            label='Ragione Sociale Agenzia' id='agencyName'
          />
        </Flex>
        <Flex style={{ width: '49.5%', marginRight: '0.5%' }}>
          <FloatInput
            type='dropdown' error={checkError && !prepayment.type} filter
            value={[prepayment?.type, (value) => setPrepayment('type', value)]}
            options={['Chiamata', 'Form', 'Link', 'Email', 'Ticket']} label='Tipo prepagamento' id='type'
          />
        </Flex>
        <Flex style={{ width: '49.5%', marginLeft: '0.5%' }}>
          <FloatInput
            type='dropdown' error={checkError && !prepayment.type} filter
            value={[prepayment?.bookingType, (value) => setPrepayment('bookingType', value)]}
            options={['Prenotazione', 'CheckIn']} label='Tipo prenotazione' id='bookingType'
          />
        </Flex>
        <Flex style={{ width: '49.5%', marginRight: '0.5%' }}>
          <FloatInput
            type='dropdown' error={checkError && !prepayment.ticketCds} filter
            value={[prepayment?.ticketCds, (value) => setPrepayment('ticketCds', value)]}
            options={[{ label: 'Sì', value: true }, { label: 'No', value: false }]}
            label='Ticket CDS' id='ticketCds'
          />
        </Flex>
        <Flex style={{ width: '100%' }}>
          <FloatInput
            error={checkError && !prepayment.note} filter
            value={[prepayment?.note, (value) => setPrepayment('note', value)]}
            label='Note' id='note' type='multiline'
          />
        </Flex>
        <Card style={{ width: '100%', marginTop: 20, padding: 10 }}>
          <Flex fw row>
            <Text value='PNR' title bold center size={20} style={{ marginLeft: '30%', width: '40%' }} />
            <Flex style={{ width: '30%' }} ae>
              <Button label='Aggiungi' icon='fa-duotone fa-plus' onClick={() => setPrepayment('prepaymentPnrs', [...(prepayment.prepaymentPnrs || []), { pnr: '', status: 'OK' }])} />
            </Flex>
          </Flex>
          <Flex fw>
            {prepayment.prepaymentPnrs
              ?.map((pnr, index) => (
                pnr.deleted
                  ? null
                  : (
                    <Flex key={index} fw row style={{ marginTop: 10 }}>
                      <Flex style={{ width: '44.5%', marginRight: '0.5%' }}>
                        <FloatInput
                          value={[pnr?.pnr, (value) => {
                            const newPnr = [...(prepayment.prepaymentPnrs || [])]
                            newPnr[index] = { ...newPnr[index], pnr: value }
                            setPrepayment('prepaymentPnrs', newPnr)
                          }]}
                          label='Pnr' id={'pnrPnr' + index}
                        />
                      </Flex>
                      <Flex style={{ width: '44.5%', marginLeft: '0.5%' }}>
                        <FloatInput
                          value={[pnr?.status, (value) => {
                            const newPnr = [...(prepayment.prepaymentPnrs || [])]
                            newPnr[index] = { ...newPnr[index], status: value }
                            setPrepayment('prepaymentPnrs', newPnr)
                          }]}
                          label='Stato' id={'pnrStatus' + index} style={{ width: '40%', marginLeft: '0.5%' }}
                          type='dropdown' options={['OK', 'Da richiamare', 'Passato a CDS']} filter
                        />
                      </Flex>
                      <Flex style={{ width: '10%' }}>
                        <Button
                          style={{ marginTop: 10 }}
                          icon='fa-duotone fa-trash' round onClick={() => {
                            const newPnrs = [...(prepayment.prepaymentPnrs || [])]
                            newPnrs[index] = { ...newPnrs[index], deleted: true }
                            setPrepayment('prepaymentPnrs', newPnrs)
                          }}
                        />
                      </Flex>
                    </Flex>)
              ))}
          </Flex>
        </Card>
      </Flex>
      <Flex fw row style={{ marginTop: 20 }}>
        <Button label='Salva' icon='fa-duotone fa-check' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/prepayment/list')} />
      </Flex>
      <TimeCounter />
    </Flex>
  )
}

const TimeCounter = () => {
  const { prepaymentId } = useParams()
  const { user = {} } = useAuth()
  const { user: userObj = {} } = user || {}
  const { id } = userObj

  useEffect(() => {
    const startDate = new Date()

    const saveTime = () => {
      if (!prepaymentId || prepaymentId === 'new') return
      if (userObj?.role === 'admin' && process.env.NODE_ENV !== 'development') return
      if ((new Date() - startDate) / 1000 < 10) return
      FC.service('timePrepayment').create({ userId: id, prepaymentId, createdAt: startDate, endAt: new Date(), time: new Date() - startDate })
    }

    window.onbeforeunload = saveTime
    return () => {
      saveTime()
      window.onbeforeunload = null
    }
  }, [])

  return null
}
